import Router from "./Router/Router";
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import Intercom, {boot} from '@intercom/messenger-js-sdk';


export default function AppWithExport(){
    const { hotelDetails, showSupportIcon } = useSelector((store) => store.login);
    const { isMobileScreen } = useSelector((store) => store.appHeader);
    
    const intercomAppId = 'wb9dag3y';
  useEffect(() => {

    if (hotelDetails && !isMobileScreen) {
      Intercom({ app_id: intercomAppId });

      boot({
        app_id: intercomAppId,
        user_id: '' + String(hotelDetails?.hotelNo),
        name: hotelDetails?.name,
        email: hotelDetails?.emailAddress,
        created_at: Math.floor(Date.now() / 1000)
      });
    }
},[hotelDetails])

useEffect(() => {
  if (!hotelDetails || isMobileScreen) return;

  window.Intercom?.('update', {
    hide_default_launcher: !showSupportIcon
  });
}, [showSupportIcon, hotelDetails, isMobileScreen]);


    return <Router></Router>

}